import 'react-international-phone/style.css';
import React from 'react'
import Api_Config from '../code/api/ApiConfig';
import { CountrySelector, ParsedCountry, PhoneInput } from "react-international-phone";
import ApiCompany from "../code/api/ApiCompany";
import Product from "../code/models/Product";
import '../css/customerinfodetail.css';
import NewCustomer from "../code/models/NewCustomer";
import ApiCustomer from "../code/api/ApiCustomer";
import Toaster from "./Toaster";

interface IAddNewCustomer {
    customerAdded: Function;
}

export default function AddNewCustomer({ customerAdded }: IAddNewCustomer) {
    const company = Api_Config.getSelectedCompany();
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const [pwdVisible, setPwdVisible] = React.useState<boolean>(false);
    const [products, setProducts] = React.useState<Product[]>([]);
    const [validUser, setValidUser] = React.useState<boolean>(false);
    const [validPwd, setValidPwd] = React.useState<boolean>(false);
    const [validForm, setValidForm] = React.useState<boolean>(true);

    const [userId, setUserId] = React.useState<string>("");
    const [userPassword1, setUserPassword1] = React.useState<string>("");
    const [userPassword2, setUserPassword2] = React.useState<string>("");
    const [nickname, setNickname] = React.useState<string>("");
    const [firstName, setFirstName] = React.useState<string>("");
    const [lastName, setLastName] = React.useState<string>("");
    const [address1, setAddress1] = React.useState<string>("");
    const [address2, setAddress2] = React.useState<string>("");
    const [city, setCity] = React.useState<string>("");
    const [state, setState] = React.useState<string>("");
    const [zipcode, setZipcode] = React.useState<string>("");
    const [country, setCountry] = React.useState<string>(company.defaultCountryCode);
    const [email, setEmail] = React.useState<string>("");
    const [phoneCountryCode, setPhoneCountryCode] = React.useState<string>("");
    const [phone, setPhone] = React.useState<string>("");
    const [companyEmployeeId, setCompanyEmployeeId] = React.useState<string>("");
    const [productIds, setProductIds] = React.useState<number[]>([]);

    const [phoneFull, setPhoneFull] = React.useState('');

    React.useEffect(() => {
        loadProducts();
    }, []);

    function loadProducts() {
        ApiCompany.getProducts().then((prods) => {
            setProducts(prods);
        });
    }

    function clear() {
        setUserId("");
        setUserPassword1("");
        setUserPassword2("");
        setNickname("");
        setFirstName("");
        setLastName("");
        setAddress1("");
        setAddress2("");
        setCity("");
        setState("");
        setZipcode("");
        setCountry("");
        setEmail("");
        setPhoneCountryCode("");
        setPhone("");
        setPhoneFull("");
        setCompanyEmployeeId("");
        setCompanyEmployeeId("");
        setProductIds([]);
        setPwdVisible(false);
        setValidUser(false);
        setValidPwd(false);
        setValidForm(true);
    }

    function validateForm(): boolean {
        let isValidForm =
            validUser &&
            validPwd &&
            !!userId &&
            !!userPassword1 &&
            !!userPassword2 &&
            !!firstName &&
            !!lastName &&
            !!email &&
            !!companyEmployeeId &&
            productIds.length > 0;

        setValidForm(isValidForm);

        return isValidForm;
    }

    function setPhoneValues(phone: string, meta: { country: ParsedCountry; inputValue: string; }): void {
        setPhoneFull(phone);
        let justThePhone = phone.replace(`+${meta.country.dialCode}`, "");
        setPhone(justThePhone);
        setPhoneCountryCode(meta.country.dialCode);
    }

    function setCountryInfo(country: ParsedCountry) {
        setCountry(country.iso2);
    }

    function togglePwdView(): void {
        setPwdVisible(!pwdVisible);
    }

    function toggleProduct(productId: number) {
        if (productIds.includes(productId)) {
            let removeProducts: number[] = [productId];

            products.forEach((prod) => {
                if (prod.parentProductId === productId) {
                    removeProducts.push(prod.productId);
                }
            });

            setProductIds(productIds.filter(id => !removeProducts.includes(id)));
        } else {
            let allNewProducts: number[] = [productId];

            products.forEach((prod) => {
                if (prod.parentProductId === productId) {
                    allNewProducts.push(prod.productId);
                }
            });
            setProductIds([...productIds, ...allNewProducts]);
        }
    }

    function buildProductSelector() {
        var isValidProduct = productIds.length > 0;
        return products.map(prod => {
            return (
                <div className={"row pad-top-" + (!!prod.parentProductId ? "10" : "20")} key={"bps_" + prod.productId}>
                    <div className={"form-check form-switch col-md-2 pad-left-" + (!!prod.parentProductId ? "15" : "5")}>
                        <input className={"form-check-input" + (isValidProduct ? "" : " is-invalid")}
                            type="checkbox" id={"checkProduct" + prod.productId} readOnly={true}
                            role="presentation" autoComplete="off" value={prod.productId} checked={productIds.includes(prod.productId)}
                            onClick={() => toggleProduct(prod.productId)} disabled={!!prod.parentProductId} />
                        <label className="form-check-label" htmlFor={"checkProduct" + prod.productId} >
                            {prod.productName}
                        </label>
                    </div>
                </div>
            )
        });
    }

    function handleAddCustomerClick(): void {
        let isValidated = validateForm();
        if (isValidated) {
            let newCustomer = new NewCustomer();
            newCustomer.userId = userId;
            newCustomer.userPassword = userPassword1;
            newCustomer.nickname = nickname;
            newCustomer.firstName = firstName;
            newCustomer.lastName = lastName;
            newCustomer.address1 = address1;
            newCustomer.address2 = address2;
            newCustomer.city = city;
            newCustomer.state = state;
            newCustomer.zipcode = zipcode;
            newCustomer.country = country;
            newCustomer.email = email;
            newCustomer.phoneCountryCode = phoneCountryCode;
            newCustomer.phone = phone;
            newCustomer.companyEmployeeId = companyEmployeeId;
            newCustomer.productIds = productIds;

            setToastMessage("");
            ApiCustomer.createNewCustomer(newCustomer).then((result) => {
                if (!!result?.customerId) {
                    setToastMessage("Customer added to the database.");
                    clear();
                    customerAdded();
                }
            });
        }
    }

    React.useEffect(() => {
        doValidateUserId();
    }, [userId]);


    function doValidateUserId() {
        if (!userId) {
            setValidUser(false);
        } else {
            ApiCustomer.validateUserId(userId).then((data) => {
                setValidUser(data);
            });
        }
    }


    React.useEffect(() => {
        setValidPwd(userPassword1 === userPassword2);
    }, [userPassword1, userPassword2]);

    return (
        <React.Fragment>
            <div className={"container" + (validForm ? "" : " was-validated")} >
                <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="inputUserId" className="form-label">User Id</label>
                        <input type="name" className={"form-control" + (validUser ? "" : " is-invalid")} id="inputUserId" autoComplete="off"
                            value={userId} onChange={(e) => setUserId(e.target.value)} required />
                        <div className="invalid-feedback">Please choose a unique user id.</div>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="inputUserPwd1" className="form-label">Password 1</label>
                        <div className="input-group">
                            <div className="input-group-text pwd-toggle" onClick={() => togglePwdView()}>{pwdVisible ? "🕶" : "👁"}</div>
                            <input type={pwdVisible ? "text" : "password"} className={"form-control" + (validPwd ? "" : " is-invalid")}
                                id="inputUserPwd1" autoComplete="off" value={userPassword1}
                                onChange={(e) => setUserPassword1(e.target.value)} required />
                            <div className="invalid-feedback">Passwords must be filled in.</div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="inputUserPwd2" className="form-label">Password 2</label>
                        <div className="input-group">
                            <div className="input-group-text pwd-toggle" onClick={() => togglePwdView()}>{pwdVisible ? "🕶" : "👁"}</div>
                            <input type={pwdVisible ? "text" : "password"} className={"form-control" + (validPwd ? "" : " is-invalid")}
                                id="inputUserPwd2" autoComplete="off" value={userPassword2}
                                onChange={(e) => setUserPassword2(e.target.value)} required />
                            <div className="invalid-feedback">Passwords must match.</div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="inputFirstname" className="form-label">First Name</label>
                        <input type="name" className="form-control" id="inputFirstname" autoComplete="off"
                            value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="inputNickname" className="form-label">Nickname</label>
                        <input type="name" className="form-control" id="inputNickname" autoComplete="off"
                            value={nickname} onChange={(e) => setNickname(e.target.value)} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="inputLastname" className="form-label">Last Name</label>
                        <input type="name" className="form-control" id="inputLastname" autoComplete="off"
                            value={lastName} onChange={(e) => setLastName(e.target.value)} required />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-5">
                        <label htmlFor="inputEmail4" className="form-label">Email</label>
                        <div className="input-group">
                            <div className="input-group-text">@</div>
                            <input type="email" className="form-control" id="inputEmail4" autoComplete="off"
                                value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="inputPhone" className="form-label">Phone</label>
                        <PhoneInput name="inputPhone" defaultCountry={company.defaultCountryCode}
                            value={phoneFull} onChange={(phone, meta) => setPhoneValues(phone, meta)} required />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <label htmlFor="inputAddress" className="form-label">Address</label>
                        <input type="text" className="form-control" id="inputAddress" placeholder="1234 Main St" autoComplete="off"
                            value={address1} onChange={(e) => setAddress1(e.target.value)} />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="inputAddress2" className="form-label">Address 2</label>
                        <input type="text" className="form-control" id="inputAddress2" placeholder="Apartment, studio, floor, etc" autoComplete="off"
                            value={address2} onChange={(e) => setAddress2(e.target.value)} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="inputCity" className="form-label">City</label>
                        <input type="text" className="form-control" id="inputCity" autoComplete="off"
                            value={city} onChange={(e) => setCity(e.target.value)} />
                    </div>
                    <div className="col-md-1">
                        <label htmlFor="inputState" className="form-label">State</label>
                        <input type="text" className="form-control" id="inputState" autoComplete="off"
                            value={state} onChange={(e) => setState(e.target.value)} />
                    </div>
                    <div className="col-md-2">
                        <label htmlFor="inputZip" className="form-label">Zip</label>
                        <input type="text" className="form-control" id="inputZip" autoComplete="off"
                            value={zipcode} onChange={(e) => setZipcode(e.target.value)} />
                    </div>
                    <div className="col-md-2">
                        <label htmlFor="inputCountry" className="form-label">Country</label>
                        <CountrySelector selectedCountry={country || company.defaultCountryCode}
                            onSelect={(country: ParsedCountry) => setCountryInfo(country)} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="inputEmployeeId" className="form-label">Employee Id</label>
                        <input type="text" className="form-control" id="inputEmployeeId" autoComplete="off" required
                            value={companyEmployeeId} onChange={(e) => setCompanyEmployeeId(e.target.value)} />
                    </div>
                </div>
                <div className="row">
                    {buildProductSelector()}
                </div>
                <div className="row">
                    <div className={"col-md-12 pad-top-20" + (validForm ? "" : " is-invalid")}>
                        <button onClick={handleAddCustomerClick} className={"btn btn-outline-primary"}>Add Customer</button>
                        <button onClick={() => clear()} className="btn btn-outline-primary pad-left-5">Clear</button>
                        <div className="invalid-feedback">All required fields must be filled in and a product must be selected.</div>
                    </div>
                </div>
            </div>
            <Toaster title={"Add New Customer"} subtitle={""} message={toastMessage} />
        </React.Fragment >
    )
}
